var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"studyVideo"},[_c('div',{staticClass:"video"},[_c('video',{attrs:{"id":"video","src":_vm.indexData.videoUrls,"controls":"controls"}})]),_c('div',{staticClass:"tips"},[_vm._v("温馨提示："+_vm._s(_vm.tips))])])
}
var staticRenderFns = []

export { render, staticRenderFns }